module.exports = __webpack_public_path__ + "assets/profile-black.9b5546e4.svg";